<div class="pagination-view container-fluid">
    <div class="dropdown-container">
      <c11n-dropdown
        (stateChange)="changeRange($event)"
        [size]="'medium'"
        [direction]="'below'"
        [hideLabel]="true"
        [hintText]="''"
        [variant]="'basic'"
        [placeholderText]="placeholderText"
        [menuData]="menuData">
      </c11n-dropdown>
    </div>
  </div>
